import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

const DeleteEnergyGroupDialog = ({
  open,
  onClose,
  selectedEnergyGroup,
  handleDeleteEnergyGroup,
  handleClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      // PaperProps={{
      //   elevation: 0,
      //   sx: {
      //     backgroundColor: (theme) =>
      //       theme.palette.mode === 'dark' ? '#000' : '#fff',
      //     border: '1px solid',
      //     borderColor: (theme) => theme.palette.divider,
      //     borderRadius: '8px',
      //     p: 2,
      //   },
      // }}
    >
      <DialogTitle>Advarsel</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Er du sikker på at du vil fjerne gruppen "{selectedEnergyGroup?.name}
          "? Tilhørende grafer og initiativer på gruppen vil også blive fjernet
          og kan ikke genskabes.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" sx={{ textTransform: 'none' }} onClick={onClose}>
          Afbryd
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            if (selectedEnergyGroup) {
              handleDeleteEnergyGroup(selectedEnergyGroup.energyGroupId);
            }
            handleClose();
          }}
          startIcon={<DeleteRoundedIcon />}
          color="error"
        >
          Fjern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteEnergyGroupDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedEnergyGroup: PropTypes.object,
  handleDeleteEnergyGroup: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DeleteEnergyGroupDialog;
